
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
	export class DataVisualsDialog extends Serenity.EntityDialog<DataVisualsRow, any> {
        protected getFormKey() { return DataVisualsForm.formKey; }
        protected getIdProperty() { return DataVisualsRow.idProperty; }
        protected getLocalTextPrefix() { return DataVisualsRow.localTextPrefix; }
        protected getNameProperty() { return DataVisualsRow.nameProperty; }
        protected getService() { return DataVisualsService.baseUrl; }

        protected form = new DataVisualsForm(this.idPrefix);

    }
}